<div class="contact-module-wrapper" [id]="componentId">
  <h4 [innerHTML]="headline"></h4>
  <div
    class="contact-module-row"
    [ngClass]="{
      'col-full': columns === 'col-12',
      'col-half': columns === 'col-6',
    }"
  >
    <div *ngFor="let group of groups || []" class="contact-module-col">
      <p
        class="contact-module-label"
        [ngClass]="{ 'contact-module-no-headline': !headline.trim().length }"
        [innerHTML]="group.label"
      ></p>
      <div class="contact-module-col-item-wrapper">
        <ng-container *ngFor="let item of group.items || []">
          <div
            class="contact-module-col-item"
            [ngClass]="{ 'bg-grey': !isBgWhite }"
            [ngStyle]="isBgWhite ? { 'background-color': backgroundColor } : {}"
          >
            <!-- Render Single Links -->
            <ng-container *ngIf="!item.list; else listLinks">
              <hdi-link
                [hrefType]="
                  item.type === 'external'
                    ? HrefType.EXTERNAL
                    : HrefType.ANGULAR_ROUTE
                "
                [href]="item.href"
                [fragment]="item.fragment ?? ''"
                [target]="item.target === 'new' ? '_blank' : '_self'"
                [title]="item.title ?? ''"
                [label]="item.linkText | capitalize"
              >
                <hdi-icon
                  [iconName]="item.icon"
                  [iconPrefix]="'far'"
                ></hdi-icon>
              </hdi-link>
            </ng-container>

            <!-- Render Link Lists -->
            <ng-template #listLinks>
              <hdi-link
                [hrefType]="HrefType.EXTERNAL"
                [href]="item.href"
                [fragment]="item.fragment ?? ''"
                [target]="'_self'"
                [title]="item.title ?? ''"
                [label]="item.linkText | capitalize"
                (click)="openModal($event, item)"
                [iconName]="item.icon"
                [iconPrefix]="'far'"
              >
              </hdi-link>
            </ng-template>
          </div>
        </ng-container>
      </div>
    </div>
  </div>

  <hdi-modal [showModal]="showModal" (closeModalTrigger)="showModal = $event">
    <div class="header-content">
      <h5>{{ modalContactItem.modalTitle }}</h5>
    </div>
    <div>
      <ng-container *ngFor="let item of modalContactItem.list; let i = index">
        <hdi-link
          class="modal-link"
          [href]="item.href ?? ''"
          [hrefType]="
            item.type === 'external'
              ? HrefType.EXTERNAL
              : HrefType.ANGULAR_ROUTE
          "
          [fragment]="item.fragment ?? ''"
          [target]="item.target === 'new' ? '_blank' : '_self'"
          [title]="item.title ?? ''"
          [label]="item.linkText ?? '' | capitalize"
          [overLabel]="item.linkLabel ?? '' | capitalize"
          [inModal]="true"
        ></hdi-link>
      </ng-container>
    </div>
  </hdi-modal>
</div>
